import React from 'react';
import { Box, Typography } from '@mui/material';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import './settingsHome.css';
import Chatbox from '../../../commun/ChatBox';

const SettingsHome = () => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userType');

  const settingsOptions = [
    {
      title: 'Paramétrage des Niveaux',
      description: 'Définir les niveaux et leurs critères.',
      path: '/admin/parametres/niveaux'
    },
    {
      title: 'Paramétrage des Badges',
      description: 'Configurer les badges attribués aux recruteurs.',
      path: '/admin/parametres/badges'
    },
    {
      title: 'Paramétrage des Primes',
      description: 'Gérer les primes attribuées aux recruteurs.',
      path: '/admin/parametres/primes'
    }
  ];

  return (
    <DashboardLayout>
      <Typography variant="h5" align="center" sx={{ mt: 4, mb: 2 }}>
        ⚙️ Paramétrages
      </Typography>

      <Box className="settings-grid">
        {settingsOptions.map((opt, index) => (
          <Box
            key={index}
            className="settings-card"
            onClick={() => navigate(opt.path)}
            role="button"
          >
            <Typography variant="h6">{opt.title}</Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>{opt.description}</Typography>
          </Box>
        ))}
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
      </Box>
    </DashboardLayout>
  );
};

export default SettingsHome;
